import {useSpecSheetStore} from '~~/stores/specsheet';

export function useSpecSheet(article: Ref<any | null>) {
    const store = useSpecSheetStore();
    const hasSpecSheet = ref(false);

    watch(
        () => article.value?.articleNumber,
        async () => {
            if (!article.value) { hasSpecSheet.value = false; return; }
            hasSpecSheet.value = await store.check(article.value);
        },
        {immediate: true},
    );

    return {hasSpecSheet};
}
